import React, { useContext } from 'react'
import { SurveyStateContext } from '../context/surveyStateContext'
import { Action } from './useSurvey/actions/action'
import { State } from './useSurvey/states/state'

export function useSurveyState(): [State, React.Dispatch<Action>] {
  return useContext(SurveyStateContext)
}
